export default __webpack_public_path__ + "static/media/Pic 2.09006742.jpg";